import { Link } from 'react-router-dom';

import Container from 'components/Container/Container';
import FooterForm from '../FooterForm/FooterForm';
import Icon from 'components/modules/Icon/Icon';

import socials from './socials.json';
import s from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={s.footer} id="footer">
      <Container>
        <div className={s.footer__container}>
          <div className={s.footer__container__position}>
            <Link to={'/'} className={s.footer_logo}>
              <span className={s.footer_logo__accent}>Ecoservice</span>Group
            </Link>
            <address>
              <ul className={s.contacts}>
                <li className={s.contacts__item}>
                  <a
                    href="https://goo.gl/maps/u2Z7PQoBGNXwkre96"
                    target="_blank"
                    rel="noreferrer noopener"
                    className={s.contacts__address}
                  >
                    Kyiv Region, Buchansky District Gorenka village, Sadova
                    street, 24-A, 08105
                  </a>
                </li>
                <li className={s.contacts__item}>
                  <a
                    href="mailto:support@ekoservice.com.ua"
                    className={s.contacts__info}
                  >
                    support@ekoservice.com.ua
                  </a>
                </li>
                <li className={s.contacts__item}>
                  <a href="tel:+380961111111" className={s.contacts__info}>
                    +38 067 333 47 00
                  </a>
                </li>
              </ul>
            </address>
          </div>
          <div className={s.footer_socials}>
            <h2 className={s.footer_socials__title}>Contact us</h2>
            <ul className={s.socials}>
              {socials.map(({ id, link, icon }) => (
                <li key={id} className={s.socials__item}>
                  {/* <Link
                    to={{ pathname: link }}
                    target="_blank"
                    className={s.socials__link__footer}
                  > */}
                  <a
                    target="_blank"
                    href={link}
                    rel="noreferrer"
                    title="example"
                    className={s.socials__link__footer}
                  >
                    <Icon id={icon} />
                  </a>
                  {/* </Link> */}
                </li>
              ))}
            </ul>
          </div>
          <FooterForm />
        </div>
      </Container>
    </footer>
  );
}
